import React, { useContext, useEffect, useState } from 'react';
import {
  YouTube,
  Telegram,
  Facebook,
  Twitter,
  Instagram,
  Edit,
  HideSource,
  Save,
  Restore,
  Cancel,
} from '@mui/icons-material';
import { Box, Button, CardContent, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material';

import StyledCardNoHeight from '../../components/card/StyledCardNoHeight';
import SERVER_API_URL from '../../config';
import { authContext } from '../../routes';
import axiosInstance from '../../api';
import CustomSnackbar from '../../components/alerts/CustomSnackbar';
import Scrollbar from '../../components/scrollbar';

export default function SocialMedia() {
  const { user } = useContext(authContext);
  const [socialMedias, setSocialMedias] = useState();
  const [editMode, setEditMode] = useState(false);
  const [notification, setNotification] = useState({});

  useEffect(() => {
    const getAllMedias = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/socialMedia/findAll`);
        if (response.status === 200) {
          setSocialMedias(response.data);
        }
      } catch (error) {
        // Handle error
      }
    };

    getAllMedias();
  }, []);

  const updateURL = (urlId, newURL) => {
    const updatedMedias = socialMedias.map((media) => {
      if (media.id === urlId) {
        return { ...media, url: newURL };
      }
      return media;
    });
    setSocialMedias(updatedMedias);
  };

  const handleSaveChanges = async () => {
    try {
      const response = await axiosInstance.put(
        `${SERVER_API_URL}/socialMedia/updateAllOnce/${user && user.id}`,
        socialMedias
      );
      if (response.status === 200) {
        setSocialMedias(response.data);
        setNotification({ message: 'በተሳካ ሁኔታ ታግዷል።', severity: 'success' });
        setEditMode(!editMode);
      }
    } catch (error) {
      setNotification({ message: 'በማገድ ላይ ችግር አለ።', severity: 'error' });
    }
  };

  const deleteURL = async (urlId) => {
    try {
      const response = await axiosInstance.delete(
        `${SERVER_API_URL}/socialMedia/deleteOneById/${urlId}/${user && user.id}`
      );
      if (response.status === 200) {
        setSocialMedias(response.data);
        notification.message = 'በተሳካ ሁኔታ ታግዷል።';
        notification.severity = 'success';
      }
    } catch (error) {
      // console.log(error)
      notification.message = 'በማገድ ላይ ችግር አለ።';
      notification.severity = 'error';
    }
  };

  const restoreURL = async (urlId) => {
    try {
      const response = await axiosInstance.patch(
        `${SERVER_API_URL}/socialMedia/restoreOneById/${urlId}/${user && user.id}`
      );
      if (response.status === 200) {
        setSocialMedias(response.data);
        notification.message = 'በተሳካ ሁኔታ ተመልሷል።';
        notification.severity = 'success';
      }
    } catch (error) {
      // console.log(error)
      notification.message = 'በመመለስ ላይ ችግር አለ።';
      notification.severity = 'error';
    }
  };

  return (
    <StyledCardNoHeight>
      {notification.message && <CustomSnackbar notification={notification} setNotification={setNotification} />}
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Typography variant="h5" sx={{ display: 'flex', justifyContent: 'space-between', color: 'darkgray' }}>
              <>ሶሻል ሚዲያ</>
              <>
                {editMode ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: { xs: 2, sm: 5 },
                      mr: { xs: 0, sm: 5 },
                      color: 'darkgray',
                    }}
                  >
                    <Tooltip title="ተመለስ">
                      <IconButton onClick={() => setEditMode(!editMode)}>
                        <Cancel sx={{ fontSize: 24 }} color="error" />
                      </IconButton>
                    </Tooltip>

                    <Button
                      onClick={handleSaveChanges}
                      variant="contained"
                      type="submit"
                      sx={{ minWidth: { xs: 30, sm: 150 } }}
                      startIcon={<Save />}
                    >
                      <Typography sx={{ display: { xs: 'none', sm: 'block' } }}>ለውጦችን አስቀምጥ</Typography>
                    </Button>
                  </Box>
                ) : (
                  <IconButton onClick={() => setEditMode(!editMode)}>
                    <Tooltip title="አርትዕ">
                      <Edit sx={{ fontSize: 24 }} color="warning" />
                    </Tooltip>
                  </IconButton>
                )}
              </>
            </Typography>
          </Grid>
          {socialMedias &&
            socialMedias.map((socialMedia) => (
              <Grid item xs={12} md={6} key={socialMedia.id}>
                <Box
                  key={socialMedia.id}
                  sx={{ display: 'flex', justifyContent: 'space-between', color: 'darkgray', mr: { xs: 0, sm: 5 } }}
                >
                  <Typography variant="h6">
                    {socialMedia.name === 'Youtube' ? (
                      <YouTube sx={{ color: 'red', pt: 1 }} />
                    ) : socialMedia.name === 'Facebook' ? (
                      <Facebook sx={{ color: '#1877F2', pt: 1 }} />
                    ) : socialMedia.name === 'Telegram' ? (
                      <Telegram sx={{ color: 'blue', pt: 1 }} />
                    ) : socialMedia.name === 'Instagram' ? (
                      <Instagram sx={{ color: '#b430b2', pt: 1 }} />
                    ) : socialMedia.name === 'Twitter' ? (
                      <Twitter sx={{ color: '#1C9CEA', pt: 1 }} />
                    ) : (
                      <></>
                    )}
                    {socialMedia.name}
                  </Typography>
                  {editMode && (
                    <IconButton>
                      {socialMedia.deleteStatus === 'ACTIVE' ? (
                        <Tooltip title="አግድ">
                          <HideSource onClick={() => deleteURL(socialMedia.id)} sx={{ fontSize: 18 }} color="error" />
                        </Tooltip>
                      ) : (
                        <Tooltip title="መልስ">
                          <Restore onClick={() => restoreURL(socialMedia.id)} sx={{ fontSize: 18 }} color="success" />
                        </Tooltip>
                      )}
                    </IconButton>
                  )}
                </Box>
                {editMode ? (
                  <Typography
                    sx={{
                      mt: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: { xs: 2, sm: 5 },
                      mr: { xs: 0, sm: 5 },
                    }}
                  >
                    <TextField
                      variant="standard"
                      fullWidth
                      value={socialMedia.url}
                      onChange={(e) => updateURL(socialMedia.id, e.target.value)}
                      disabled={socialMedia.deleteStatus === 'DELETED'}
                    />
                  </Typography>
                ) : (
                  <>
                    {socialMedia.deleteStatus === 'ACTIVE' ? (
                      <Scrollbar>
                        <Typography sx={{ mt: 1 }}>{socialMedia.url}</Typography>
                      </Scrollbar>
                    ) : (
                      <Scrollbar>
                        <Typography sx={{ mt: 1, color: 'darkgray' }}>{socialMedia.url}</Typography>
                      </Scrollbar>
                    )}
                  </>
                )}
              </Grid>
            ))}
        </Grid>
      </CardContent>
    </StyledCardNoHeight>
  );
}
